import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import colors from 'vuetify/util/colors'

const myCustomLightTheme = {
  dark: false,
  colors: {
    primary: '#e30613',
    'primary-lighten-1': '#e30613'
  }
}

export default createVuetify({
  components,
  directives,
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme
    }
    /* themes: {
      light: {
        colors: {
          //primary: colors.blue.darken2,
          primary: '#e30613',
          secondary: colors.grey.darken1,
          accent: colors.shades.black,
          error: colors.purple.accent4,
          //error: colors.red.accent3,
        }
      },
      dark: {
        colors: {
          primary: colors.blue.lighten3,
        }
      },
    } */
  }
});
